import { ajax } from "@/assets/js/ajax";


export function debtorFiles (data) {     //案件列表
  return ajax({
    url: 'debtor/files',
    type: 'get',
    data: data
  })
}
export function commentsFiles (data) {     //案件列表
  return ajax({
    url: 'cause/comments/files',
    type: 'get',
    data: data
  })
}
export function debtorDel (data) {     //删除案件
  return ajax({
    url: 'debtor/del',
    type: 'post',
    data: data
  })
}
export function debtorHis (data) {     //案件列表
  return ajax({
    url: 'debtor/audits',
    type: 'get',
    data: data
  })
}
export function debtorInfo (data) {     //债务人详情
  return ajax({
    url: 'debtor/info',
    type: 'get',
    data: data
  })
}
export function debtorOther (id, data) {
  return ajax({
    url: id ? 'debtor/other/edit' : 'debtor/other/add',     //修改   //新增
    type: 'post',
    data: data
  })
}

export function delOther (data) {
  return ajax({
    url: 'debtor/other/del',     //删除
    type: 'post',
    data: data
  })
}
export function debtorExpire (data) {
  return ajax({
    url: 'debtor/keep/expire',
    type: "get",
    data: data
  })
}


export function debtorKeepAdd (data) {    //添加保全记录
  return ajax({
    url: 'debtor/keep/add',
    type: "post",
    data: data
  })
}

export function debtorKeepDel (data) {    //删除保全记录
  return ajax({
    url: 'debtor/keep/del',
    type: "get",
    data: data
  })
}

export function debtorKeepEdit (data) {    //修改保全记录
  return ajax({
    url: 'debtor/keep/edit',
    data: data
  })
}


export function debtorUrge (data) {   //添加催收记录
  return ajax({
    url: 'debtor/urge',
    type: "post",
    data: data,
    contentType: "application/json"
  })
}
export function commentAdd (data) {      //新增历史记录
  return ajax({
    url: 'cause/comment/add',
    contentType: "application/json",
    type: 'post',
    data: data
  })
}
export function commentEdit (data) {      //修改历史记录
  return ajax({
    url: 'cause/comment/edit',
    contentType: "application/json",
    type: 'post',
    data: data
  })
}
export function commentDel (data) {      //删除历史记录
  return ajax({
    url: 'cause/comment/del',
    type: 'get',
    data: data
  })
}

export function CaseAdd (data) {        //新增案件
  return ajax({
    url: 'cause/add',
    type: 'post',
    data: data
  })
}

export function CaseEdit (data) {        //新增案件
  return ajax({
    url: 'cause/edit',
    type: 'post',
    data: data
  })
}
export function stepFiles (data) {
  return ajax({
    url: 'step/files',
    type: "get",
    data: data
  })
}
export function delFiles (data) {
  return ajax({
    url: 'step/del',
    data: data
  })
}


export function keepAlways (data) {
  return ajax({
    url: 'debtor/keep/always',
    type: "get",
    data: data
  })
}

// export function editAgentModel(data) {
//   return ajax({
//     url: 'cause/editAgentModel',
//     type: 'put',
//     data: data
//   })
// }
export function causeEditNote (data) {
  return ajax({
    url: 'cause/editNote',
    data: data
  })
} 1
1
export function commonList (data, type) {
  1
  return ajax({
    //url: type == 3 ? 'cause/comments/causeExecList' : 'cause/comments/index?connect_type=' + type,1
    url: 'cause/comments/index?connect_type=' + type,
    data: data,
    type: "get"
  })
}

export function shareAdd (data) { //分享
  return ajax({
    url: 'cause/share/add',
    type: 'post',
    data: data
  })
}

export function shareList (data) { //分享
  return ajax({
    url: 'cause/share/index',
    type: 'get',
    data: data
  })
}
export function shareinfo (data) {
  return ajax({
    url: 'cause/share/info',
    type: 'get',
    data: data
  })
}

export function shareFile (data) {
  return ajax({
    url: 'cause/share/getFileList',
    type: 'get',
    data: data
  })
}

export function statisData (data, type) {
  return ajax({
    url: type == 'list' ? 'statis/newData/debtorList' : 'statis/newData/index',
    type: 'get',
    data: data
  })
}

export function statisPayee (data, type) {
  return ajax({
    url: type == 1 ? 'statis/payee/index' : 'statis/payee/loanPeriodSum',
    type: 'get',
    data: data
  })
}

export function payeeList (data) {
  return ajax({
    url: 'statis/payee/causeList',
    type: 'get',
    data: data
  })
}

export function auction (data, type) {
  return ajax({
    url: `auction/${type}`,
    type: (type == 'del' || type == 'index') ? 'get' : 'post',
    data: data
  })
}

export function auctionAdd (data) {
  return ajax({
    url: 'auction/setNotRemind',
    type: 'get',
    data: data
  })
}

export function AgetCounts (data) {
  return ajax({
    url: 'auction/getCounts',
    type: 'get',
    data: data
  })
}

export function groupCount (data) {
  return ajax({
    url: 'cause/comments/getCounts',
    type: 'get',
    data: data
  })
}
export function newDebtorData (data) {
  return ajax({
    url: 'statis/newDebtorData/getTopData',
    type: 'get',
    data: data
  })
}
export function newDebtorDataList (data) {
  return ajax({
    url: 'statis/newDebtorData/getDebtorList',
    type: 'get',
    data: data
  })
}

export function newCauseData (data) {
  return ajax({
    url: 'statis/newCauseData/getTopData',
    type: 'get',
    data: data
  })
}
export function newCauseDataList (data) {
  return ajax({
    url: 'statis/newCauseData/getDebtorList',
    type: 'get',
    data: data
  })
}
export function newStepData (data) {
  return ajax({
    url: 'statis/newStepData/getTopData',
    type: 'get',
    data: data
  })
}
///statis/newStepData/getDebtorList
export function newStepDataList (data) {
  return ajax({
    url: 'statis/newStepData/getDebtorList',
    type: 'get',
    data: data
  })
}

export function shareHis (data) {
  return ajax({
    url: 'cause/share/history',
    type: 'get',
    data: data
  })
}

export function feeList (data) {
  return ajax({
    url: 'statis/loan/feeList',
    type: 'get',
    data: data
  })
}

//statis/loan/debtorList

export function defeeList (data) {
  return ajax({
    url: 'statis/loan/debtorList',
    type: 'get',
    data: data
  })
}
